import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useLocation } from '@grandvisionhq/frk-routing';
import Link from '../Link/Link.js';

const RouterLink = (props)=>{
    const { push  } = useLocation();
    const onClickHandler = (e)=>{
        var ref;
        if (props === null || props === void 0 ? void 0 : props.href) {
            e === null || e === void 0 ? void 0 : e.preventDefault();
            push(props === null || props === void 0 ? void 0 : props.href);
        }
        props === null || props === void 0 ? void 0 : (ref = props.onClick) === null || ref === void 0 ? void 0 : ref.call(props, e);
    };
    return /*#__PURE__*/ React.createElement(Link, swcHelpers.extends({}, props, {
        onClick: onClickHandler
    }));
};

export { RouterLink as default };
//# sourceMappingURL=RouterLink.js.map
